import BitmapText from 'core/display/simple/BitmapText'
import TextCreate from 'core/display/simple/Text'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class WinText extends PIXI.Container {
  constructor(data) {
    super()

    this.self = data.fontBitmap ? new BitmapText(data) : new TextCreate(data)
    if(data.hide) {
      this.self.visible  = false
    }
    this.self.tween = { value: 0 }

    signal.on('WIN-COLLECT', this.animate.bind(this))
    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.animate.bind(this))
    signal.on('WIN-COLLECT-GAMBLE:WIN', this.animateGambleWin.bind(this))
    signal.on('WIN-COLLECT-GAMBLE:LOSE', this.animateResetGamble.bind(this))
    signal.on('ACTION:REQUEST-SPIN', this.reset.bind(this))
    signal.on('STATE:OUT:FS-START', this.reset.bind(this))
    signal.on('RECOVERY:RE-SPIN-LAST-WIN', this.animateRecovery.bind(this))

    this.addChild(this.self)
    this.reset()
  }

  onUpdate() {
    const sing = !this.self.isBitmap
    const value = FormatService.currency(this.self.tween.value, sing )
    this.self.update(value)
  }

  reset() {
    gsap.killTweensOf(this.self.tween)
    this.self.tween.value = 0
    this.onUpdate()
  }

  animate({ type, amount }) {
    const value = this.self.tween.value + amount
    const winTween = gsap.to(this.self.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }

  animateGambleWin({ amount }) {
    gsap.killTweensOf(this.self.tween)
    this.self.tween.value = amount
    this.onUpdate()
  }

  animateResetGamble() {
    gsap.killTweensOf(this.self.tween)
    this.self.tween.value = 0
    this.onUpdate()
  }

  animateRecovery({ type, amount }) {
    this.visible = true
    const value = this.self.tween.value + amount
    const winTween = gsap.to(this.self.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }

  animateUpdate({ type, amount }) {

    const value = amount
    const winTween = gsap.to(this.self.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }
}
